import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Icon from '../assets/icon.svg';

const UnsubscribeSimple = () => {
  console.log('UnsubscribeSimple component loaded');
  
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    reason: '',
    customReason: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const emailParam = searchParams.get('email');
    if (emailParam) {
      setFormData(prev => ({ ...prev, email: emailParam }));
    }
  }, [searchParams]);

  const reasons = [
    { value: 'too-frequent', label: 'Emails are too frequent' },
    { value: 'not-relevant', label: 'Content is not relevant to me' },
    { value: 'never-signed-up', label: 'I never signed up for these emails' },
    { value: 'spam', label: 'I consider these emails as spam' },
    { value: 'other', label: 'Other reason' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch('/api/unsubscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        setMessage(data.message);
        setMessageType('success');
        setIsSuccess(true);
      } else {
        setMessage(data.message || 'An error occurred');
        setMessageType('error');
      }
    } catch (error) {
      setMessage('Network error. Please try again.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
      <header style={{ 
        backgroundColor: 'white', 
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)', 
        padding: '1rem 0',
        position: 'sticky',
        top: 0,
        zIndex: 1000
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <img 
                src={Icon} 
                alt="AppActs Logo" 
                style={{ 
                  width: '32px', 
                  height: '32px',
                  objectFit: 'contain'
                }}
              />
              <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', margin: 0 }}>AppActs</h1>
            </div>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
              <button
                onClick={() => navigate('/')}
                style={{ 
                  color: '#6b7280', 
                  cursor: 'pointer', 
                  border: 'none', 
                  background: 'none',
                  fontSize: '0.875rem',
                  textDecoration: 'none'
                }}
              >
                Home
              </button>
              <button
                onClick={() => navigate('/about')}
                style={{ 
                  color: '#6b7280', 
                  cursor: 'pointer', 
                  border: 'none', 
                  background: 'none',
                  fontSize: '0.875rem',
                  textDecoration: 'none'
                }}
              >
                About
              </button>
              <button
                onClick={() => navigate('/contact')}
                style={{ 
                  color: '#6b7280', 
                  cursor: 'pointer', 
                  border: 'none', 
                  background: 'none',
                  fontSize: '0.875rem',
                  textDecoration: 'none'
                }}
              >
                Contact
              </button>
            </div>
          </div>
        </div>
      </header>
      
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '3rem 1rem' }}>
        <div style={{ maxWidth: '42rem', margin: '0 auto' }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#111827', marginBottom: '0.5rem' }}>
              Unsubscribe from AppActs
            </h1>
            <p style={{ color: '#6b7280', fontSize: '1.125rem' }}>
              We're sorry to see you go. Please let us know why you're unsubscribing.
            </p>
          </div>

          {/* Features Section */}
          <div style={{ 
            backgroundColor: 'white', 
            borderRadius: '0.75rem', 
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)', 
            padding: '2rem',
            marginBottom: '2rem'
          }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem', textAlign: 'center' }}>
              What You'll Miss
            </h2>
            <p style={{ color: '#6b7280', textAlign: 'center', marginBottom: '2rem' }}>
              Here's what you'll be missing from our platform:
            </p>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
              <div style={{ 
                padding: '1.5rem', 
                backgroundColor: '#ffffff', 
                borderRadius: '0.75rem',
                border: '1px solid #e5e7eb',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.2s ease'
              }}>
                <div style={{ 
                  width: '2.5rem', 
                  height: '2.5rem', 
                  backgroundColor: '#f3f4f6', 
                  borderRadius: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem',
                  fontSize: '1.125rem',
                  color: '#6b7280'
                }}>
                  📄
                </div>
                <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', marginBottom: '0.5rem' }}>
                  Legal Document Generator
                </h3>
                <p style={{ fontSize: '0.875rem', color: '#6b7280', lineHeight: '1.6' }}>
                  Generate GDPR-compliant privacy policies, terms of service, and other legal documents in minutes.
                </p>
              </div>

              <div style={{ 
                padding: '1.5rem', 
                backgroundColor: '#ffffff', 
                borderRadius: '0.75rem',
                border: '1px solid #e5e7eb',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.2s ease'
              }}>
                <div style={{ 
                  width: '2.5rem', 
                  height: '2.5rem', 
                  backgroundColor: '#f3f4f6', 
                  borderRadius: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem',
                  fontSize: '1.125rem',
                  color: '#6b7280'
                }}>
                  🔗
                </div>
                <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', marginBottom: '0.5rem' }}>
                  Smart URL Shortener
                </h3>
                <p style={{ fontSize: '0.875rem', color: '#6b7280', lineHeight: '1.6' }}>
                  Create intelligent short links with platform-specific redirects and detailed click analytics.
                </p>
              </div>

              <div style={{ 
                padding: '1.5rem', 
                backgroundColor: '#ffffff', 
                borderRadius: '0.75rem',
                border: '1px solid #e5e7eb',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.2s ease'
              }}>
                <div style={{ 
                  width: '2.5rem', 
                  height: '2.5rem', 
                  backgroundColor: '#f3f4f6', 
                  borderRadius: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem',
                  fontSize: '1.125rem',
                  color: '#6b7280'
                }}>
                  🎧
                </div>
                <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', marginBottom: '0.5rem' }}>
                  Customer Support System
                </h3>
                <p style={{ fontSize: '0.875rem', color: '#6b7280', lineHeight: '1.6' }}>
                  Manage customer tickets, support modules, and provide professional customer service.
                </p>
              </div>

              <div style={{ 
                padding: '1.5rem', 
                backgroundColor: '#ffffff', 
                borderRadius: '0.75rem',
                border: '1px solid #e5e7eb',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.2s ease'
              }}>
                <div style={{ 
                  width: '2.5rem', 
                  height: '2.5rem', 
                  backgroundColor: '#f3f4f6', 
                  borderRadius: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem',
                  fontSize: '1.125rem',
                  color: '#6b7280'
                }}>
                  🚀
                </div>
                <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#111827', marginBottom: '0.5rem' }}>
                  Internal Ads Management
                </h3>
                <p style={{ fontSize: '0.875rem', color: '#6b7280', lineHeight: '1.6' }}>
                  Create and manage internal advertisements to promote your products within your app.
                </p>
              </div>
            </div>

            <div style={{ 
              backgroundColor: '#fef3c7', 
              border: '1px solid #f59e0b', 
              borderRadius: '0.5rem', 
              padding: '1rem', 
              marginTop: '1.5rem',
              textAlign: 'center'
            }}>
              <p style={{ color: '#92400e', fontSize: '0.875rem', margin: '0 0 1rem 0' }}>
                <strong>All-in-One Platform:</strong> Instead of managing 7 different platforms, use just one!
              </p>
              <button
                onClick={() => navigate('/')}
                style={{
                  backgroundColor: '#f59e0b',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  borderRadius: '0.375rem',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '0.875rem',
                  fontWeight: '500'
                }}
              >
                Stay with us - Explore Platform
              </button>
            </div>
          </div>

          {/* Success Message */}
          {isSuccess && (
            <div style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '0.5rem', padding: '1.5rem', marginBottom: '1.5rem' }}>
              <h3 style={{ color: '#166534', marginBottom: '1rem', fontSize: '1.125rem', fontWeight: '600' }}>
                Successfully Unsubscribed
              </h3>
              <p style={{ color: '#166534', marginBottom: '1rem' }}>
                You have been removed from our mailing list. You will no longer receive marketing emails from AppActs.
              </p>
              <button
                onClick={() => navigate('/')}
                style={{ backgroundColor: '#166534', color: 'white', padding: '0.5rem 1rem', borderRadius: '0.375rem', border: 'none', cursor: 'pointer' }}
              >
                Back to Home
              </button>
            </div>
          )}

          {/* Unsubscribe Form */}
          {!isSuccess && (
            <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', padding: '2rem' }}>
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                {/* Email Field */}
                <div>
                  <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem' }}
                    placeholder="Enter your email address"
                  />
                </div>

                {/* Reason Selection */}
                <div>
                  <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.75rem' }}>
                    Why are you unsubscribing?
                  </label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    {reasons.map((reason) => (
                      <label key={reason.value} style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                          type="radio"
                          name="reason"
                          value={reason.value}
                          checked={formData.reason === reason.value}
                          onChange={handleInputChange}
                          required
                          style={{ marginRight: '0.75rem' }}
                        />
                        <span style={{ fontSize: '0.875rem', color: '#374151' }}>{reason.label}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Custom Reason */}
                {formData.reason === 'other' && (
                  <div>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
                      Please specify your reason
                    </label>
                    <textarea
                      name="customReason"
                      value={formData.customReason}
                      onChange={handleInputChange}
                      rows={3}
                      style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem' }}
                      placeholder="Please tell us more about why you're unsubscribing..."
                    />
                  </div>
                )}

                {/* Message Display */}
                {message && (
                  <div style={{
                    padding: '1rem',
                    borderRadius: '0.375rem',
                    backgroundColor: messageType === 'success' ? '#f0fdf4' : '#fef2f2',
                    border: `1px solid ${messageType === 'success' ? '#bbf7d0' : '#fecaca'}`,
                    color: messageType === 'success' ? '#166534' : '#dc2626'
                  }}>
                    {message}
                  </div>
                )}

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={loading || !formData.email || !formData.reason}
                  style={{
                    backgroundColor: loading || !formData.email || !formData.reason ? '#9ca3af' : '#dc2626',
                    color: 'white',
                    padding: '0.75rem 1.5rem',
                    borderRadius: '0.375rem',
                    border: 'none',
                    cursor: loading || !formData.email || !formData.reason ? 'not-allowed' : 'pointer',
                    fontSize: '0.875rem',
                    fontWeight: '500'
                  }}
                >
                  {loading ? 'Processing...' : 'Unsubscribe'}
                </button>
              </form>
            </div>
          )}

          {/* Additional Information */}
          <div style={{ marginTop: '2rem', textAlign: 'center', fontSize: '0.875rem', color: '#6b7280' }}>
            <p>
              If you have any questions or concerns, please{' '}
              <a href="/contact" style={{ color: '#2563eb', textDecoration: 'underline' }}>
                contact our support team
              </a>
              .
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ backgroundColor: '#1f2937', color: 'white', padding: '2rem 0', marginTop: 'auto' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem', textAlign: 'center' }}>
          <p>&copy; 2025 AppActs. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default UnsubscribeSimple;
